import axios from "axios";
import { LangType } from "../types/LangType";

export const StabilityAiTransport = {
    getImage: async (prompt: string): Promise<any> => {
        const { data } = await axios.get(`/stabilityAi/getImage?prompt=${prompt}`, {});
        return data.message;
    },
    getImageByJarvisPrompt: async (
        title: string,
        lang: LangType
    ): Promise<any> => {
        const { data } = await axios.get(
            `/stabilityAi/getImage/byJarvisPrompt?title=${title}&lang=${lang}`,
            {}
        );
        return data.message;
    },
};
